@if (routeData) {
<div class="planned-data">
  <div class="flex-outer">
    <div class="flex-column">
      <div class="data-element">
        <div class="data-name">{{ languageService.languageJSON.Global_Distance }}</div>
        @if (hasData) {
          @let d = distanceDisplay;
          <div class="data-value">
            <div class="value-el">
            @if (d.isThousands) {
              {{ d.value | turnValueIntegerThousands }}
            } @else {
              {{ d.value | valueInteger }}
            }
            </div>
            <small>{{ d.unit }}</small>
          </div>
        } @else {
          <div class="data-value">--</div>
        }
      </div>
      <div class="data-element">
        <div class="data-name">{{ languageService.languageJSON.InfoSidebar_TotalTime }}</div>
        @if (hasData) {
          <div class="data-value">{{ utilsService.timeConverter(routeData.RouteInfo.TotalTime) }}</div>
        } @else {
          <div class="data-value">--</div>
        }
      </div>
    </div>
    <div class="flex-column">
      <div class="data-element">
        <div class="data-name">{{ languageService.languageJSON.InfoSidebar_ChargingTime }}</div>
        @if (hasData) {
          <div class="data-value">{{ utilsService.timeConverter(routeData.RouteInfo.ChargeTime) }}</div>
        } @else {
          <div class="data-value">--</div>
        }
      </div>
      <div class="data-element">
        <div class="data-name">{{ languageService.languageJSON.InfoSidebar_ChargingStops }}</div>
        @if (hasData) {
          <div class="data-value">{{ routeData.RouteInfo.ChargingStops }}</div>
        } @else {
          <div class="data-value">--</div>
        }
      </div>
    </div>
  </div>
  <div class="data-element">
    <div class="data-name">{{ languageService.languageJSON.Global_TotalConsumption }}</div>
    @if (hasData) {
      <div class="data-value">{{ routeData.RouteInfo.TotalConsumption }} <small>kWh</small></div>
    } @else {
      <div class="data-value">--</div>
    }
  </div>
</div>
}
